import { render, staticRenderFns } from "./SaleProjectModal.vue?vue&type=template&id=53147c36"
import script from "./SaleProjectModal.vue?vue&type=script&lang=js"
export * from "./SaleProjectModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports